module.exports = __webpack_public_path__ + "img/bg-hero.bc0984ca.svg";